export class ParametersProgram{
    notaMinima: number;
}
